import React, { useState, useContext, useEffect } from "react"
import "./notifications.css"
import Notifications from "./notifications"
import OutsideClickHandler from "react-outside-click-handler"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBell } from "@fortawesome/pro-regular-svg-icons"
import { faBell as faBellSolid } from "@fortawesome/pro-solid-svg-icons"
import { FirebaseContext } from "../../Firebase"

const NotificationsDropdown = () => {
  const [showDropdown, setShowDropdown] = useState(false)
  const bellButtonRef = React.useRef(null)
  const {
    localFirestore: { notificationsRecord, markUserNotificationsAsRead },
    notifier,
  } = useContext(FirebaseContext)
  const unreadNotificationCount = notificationsRecord.filter((notification) => !notification.isRead).length

  const focusBellButton = () => {
    bellButtonRef.current?.focus()
  }

  const focusFirstNotificationItem = () => {
    if (typeof document === 'undefined') return false
    const firstNotification = document.querySelector('.notifications-list-item:not(.empty)')
    if (!(firstNotification instanceof HTMLElement)) return false
    firstNotification.focus()
    return true
  }

  const handleToggleDropdown = (e) => {
    e.preventDefault()
    setShowDropdown(!showDropdown)

    if (showDropdown){
      markUserNotificationsAsRead()
    } 
  }

  const handleOutsideClick = (e) => {
    e.preventDefault()
    // handles outside click for notifications dropdown
    if (
      e?.target?.parentNode?.classList?.contains("notifications-icon-svg") ||
      e?.target?.parentNode?.classList?.contains("notifications-icon") ||
      e?.target?.parentNode?.classList?.contains("notifications-dropdown")
    ) {
      return
    }
    markUserNotificationsAsRead()
    setShowDropdown(false)
  }

  const handleBellKeyDown = (e) => {
    if (e.key !== 'ArrowDown') return

    e.preventDefault()
    e.stopPropagation()

    if (showDropdown) {
      focusFirstNotificationItem()
      return
    }

    setShowDropdown(true)
    requestAnimationFrame(() => {
      focusFirstNotificationItem()
    })
  }

  const handleDropdownKeyDown = (e) => {
    if (e.key !== 'Escape') return
    e.preventDefault()
    e.stopPropagation()
    markUserNotificationsAsRead()
    setShowDropdown(false)
    requestAnimationFrame(() => {
      focusBellButton()
    })
  }

  useEffect(() => {
    if (showDropdown) {
      notifier.disableNotifications()
    } else {
      notifier.enableNotifications()
    }
  }, [showDropdown])

  return (
    <div className="notifications-dropdown printer-none">
      <button
        ref={bellButtonRef}
        type="button"
        className={`notifications-icon ${showDropdown ? 'showing' : ''}`}
        onClick={handleToggleDropdown}
        onKeyDown={handleBellKeyDown}
        aria-label="Notifications"
        aria-haspopup="menu"
        aria-expanded={showDropdown}
      >
        <FontAwesomeIcon className="notifications-icon-svg" icon={showDropdown ? faBellSolid : faBell} />
        {unreadNotificationCount > 0 && !notifier.isDisabled && (
          <div className="notification-indicator">
            <span>{unreadNotificationCount}</span>
          </div>
        )}
      </button>
      {showDropdown && (
        <OutsideClickHandler onOutsideClick={handleOutsideClick}>
          <div className="dropdown-content" onKeyDown={handleDropdownKeyDown}>
            <Notifications setShowDropdown={setShowDropdown} focusBellButton={focusBellButton} />
          </div>
        </OutsideClickHandler>
      )}
    </div>
  )
}

export default NotificationsDropdown
